import React from "react";
import { FaqMain, FaqSection, FaqWrapper } from "../components/Faq/Faq.styled";

export const DisclaimerPage = () => {
  return (
    <FaqWrapper>
      <div className='container'>
        <FaqMain>
          <h2>Tontake Safety Disclaimer</h2>
          <span>June 1, 2022</span>
          <FaqSection>
            <h3>Disclaimer:</h3>
            <p>
              Getgems has no connections with projects on its NFT marketplace. We are not responsible for potential losses from engaging in the
              purchase of NFTs or any activity on our platform. Heed the possible risks when investing.
            </p>
            <p>
              Remember that buying an NFT has zero guarantees you’ll instantly turn a profit. Before anything else, NFTs represent many things, such
              as a symbol of crypto enthusiasm, something to collect, and a novel technology, after which it may become an investment instrument.
            </p>
            <p>Below are a few pointers to remember when trying to steer clear of scams.</p>
            <p>
              <ul>
                <li>
                  To stay in touch with our marketplace, only use official support accounts (@nfton_bot), and to get official information from us, you
                  can visit our @getgems Telegram channel.
                </li>

                <li>
                  Never share your private keys or your seed phrase with anyone. This rule is an old staple of the crypto industry, yet it’s worth
                  repeating. Your seed phrase literally gives direct access to your crypto funds in your wallet. Protect it wisely.
                </li>

                <li>Only use recommended wallets when interacting with Getgems — TON Wallet and Tonkeeper.</li>

                <li>
                  Never click on links if they look suspicious. To be safe, double-check the link to ensure it’ll take you to the official site
                  instead; otherwise, you risk losing an NFT or money.
                </li>

                <li>
                  If something looks too good to be true, there’s a high probability that you’ve facing a scam. Stay away from projects that promise
                  impossibly high returns.
                </li>
              </ul>
            </p>
          </FaqSection>
        </FaqMain>
      </div>
    </FaqWrapper>
  );
};
